import _ from 'lodash';
import { validate } from 'revalidator';
import { allowedPrefContactMethods, phoneIsValid, zipIsValid } from '../../lib/validator-helpers';
import {
	PREFERRED_CONTACT_METHODS,
	COUNTRIES,
	LOCATION_TYPES,
	PHONE_TYPES
} from '../../constants/constants';

export default function validateLocation (form) {
	let lesseeIsPresent = (form.lesseeIsPresent === 'true');

	function statesEnum (country) {
		const chosenCountry = COUNTRIES
			.find(c => c.value === country);
		if (chosenCountry !== undefined) {
			return chosenCountry
				.states
				.map(state => state.value);
		} else {
			return [];
		}
	}

	let allowedContactMethods = PREFERRED_CONTACT_METHODS[Object.keys(PREFERRED_CONTACT_METHODS)[0]].options.map(type => type.value);
	if (lesseeIsPresent) {
		allowedContactMethods.push('');
	}

	let allowedPhoneTypes = _.cloneDeep(PHONE_TYPES);
	if (lesseeIsPresent) {
		allowedPhoneTypes.push('');
	}

	return validate(form, {
		type: 'object',
		properties: {
			locationType: {
				type: 'string',
				required: true,
				allowEmpty: false,
				enum: LOCATION_TYPES[Object.keys(LOCATION_TYPES)[0]].map(type => type.value),
				message: 'fieldIsRequired'
			},

			locationName: {
				type: 'string',
				required: false
			},

			country: {
				type: 'string',
				required: true,
				allowEmpty: false,
				enum: COUNTRIES.map(c => c.value),
				message: 'fieldIsRequired'
			},

			street1: {
				type: 'string',
				required: true,
				allowEmpty: false,
				message: 'fieldIsRequired'
			},

			street2: {
				type: 'string',
				required: false
			},

			city: {
				type: 'string',
				required: true,
				allowEmpty: false,
				message: 'fieldIsRequired'
			},

			state: {
				type: 'string',
				required: true,
				allowEmpty: false,
				enum: statesEnum(form.country),
				message: 'fieldIsRequired'
			},

			zip: {
				type: 'string',
				required: true,
				allowEmpty: false,
				conform: zip => !zip || zipIsValid(form.country, zip),
				messages: {
					required: 'fieldIsRequired',
					allowEmpty: 'fieldIsRequired',
					conform: 'enterValidZip'
				}
			},

			lesseeIsPresent: {
				type: 'string',
				required: true,
				allowEmpty: false,
				enum: ['true', 'false'],
				message: 'fieldIsRequired'
			},

			onSiteContactFirstName: {
				type: 'string',
				required: !lesseeIsPresent,
				allowEmpty: lesseeIsPresent,
				message: 'fieldIsRequired'
			},

			onSiteContactLastName: {
				type: 'string',
				required: !lesseeIsPresent,
				allowEmpty: lesseeIsPresent,
				message: 'fieldIsRequired'
			},

			onSiteContactPhone: {
				type: 'string',
				required: !lesseeIsPresent,
				allowEmpty: lesseeIsPresent,
				conform: phone => !phone || phoneIsValid(phone),
				messages: {
					allowEmpty: 'fieldIsRequired',
					conform: 'enterValidPhone'
				}
			},

			onSiteContactPhoneType: {
				type: 'string',
				required: !lesseeIsPresent,
				allowEmpty: lesseeIsPresent,
				enum: allowedPhoneTypes,
				message: 'fieldIsRequired'
			},

			onSiteContactEmail: {
				type: 'string',
				format: lesseeIsPresent ? 'string' : 'email',
				required: !lesseeIsPresent,
				allowEmpty: lesseeIsPresent,
				messages: {
					required: 'fieldIsRequired',
					allowEmpty: 'fieldIsRequired',
					format: 'enterValidEmail'
				}
			},

			onSiteContactPrefMethod: {
				type: 'string',
				// TODO: Re-enable preferred contact method later (required: !lesseeIsPresent,)
				required: false,
				allowEmpty: lesseeIsPresent,
				enum: allowedPrefContactMethods(lesseeIsPresent, form.onSiteContactPhoneType),
				messages: {
					required: 'fieldIsRequired',
					allowEmpty: 'fieldIsRequired',
					enum: 'fieldIsRequired'
				}
			}
		}
	});
}
